var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.income
    ? _c(
        "app-purchase-chart",
        {
          attrs: {
            "chart-data": _vm.income,
            "show-prev-year": true,
            "max-to-show-years": _vm.maxToShowYears,
            "chart-type": "area",
          },
        },
        [
          _c("template", { slot: "title" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$ct("purchases-per-month")) +
                " - " +
                _vm._s(_vm.$ct("compare")) +
                " "
            ),
          ]),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }